import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, EmendasParlamentaresReducer, EmendasParlamentaresState } from "./emendas-parlamentares-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IEmendaParlamentarPagedResponse } from "models/response/emenda-parlamentar-paged-response";

const EmendasParlamentaresContext = createContext<EmendasParlamentaresState | undefined>(undefined);
const EmendasParlamentaresContextDispatchContext = createContext({} as any);

const EmendasParlamentaresProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(EmendasParlamentaresReducer, {
        emendas: new PaginationResponse<IEmendaParlamentarPagedResponse>([], 0, 1, 10, 0),
        emendaPagedRequest: { page: 0, pageSize: 10 },
        tipos: [],
        formasRepasse: [],
        ultimaAtualizacao: null,
        totais: { valorTotalPrevisto: 0, valorTotalRealizado: 0 },
        loading: false,
        error: null
    } as EmendasParlamentaresState);

    return (
        <EmendasParlamentaresContext.Provider value={state}>
            <EmendasParlamentaresContextDispatchContext.Provider value={dispatch}>
                {children}
            </EmendasParlamentaresContextDispatchContext.Provider>
        </EmendasParlamentaresContext.Provider>
    );
}

const useEmendasParlamentaresState = () => {
    const context = useContext(EmendasParlamentaresContext);
    if (context === undefined) {
        throw new Error('useEmendasParlamentaresState must be used within a EmendasParlamentaresProvider');
    }
    return context;
}

const useEmendasParlamentaresDispatch = () => {
    const context = useContext(EmendasParlamentaresContextDispatchContext);
    if (context === undefined) {
        throw new Error('useEmendasParlamentaresDispatch must be used within a EmendasParlamentaresProvider');
    }
    return context;
}

export { EmendasParlamentaresProvider, useEmendasParlamentaresState, useEmendasParlamentaresDispatch, ACTION_TYPES };
